var firebase = require("firebase");
var firebaseConfig = {
  apiKey: "AIzaSyDwSUQVvlVuqavuRNPN6pxLE9IWtW6rDaY",
  authDomain: "lessons-portal.firebaseapp.com",
  databaseURL: "https://lessons-portal.firebaseio.com",
  projectId: "lessons-portal",
  storageBucket: "lessons-portal.appspot.com",
  messagingSenderId: "892656603508",
  appId: "1:892656603508:web:6a2ce0a8f96ac7b9ea1c21"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export var database = firebase.firestore();

export var db = {
  addMember: (roomId, userId, alias) => {
    return database
      .collection("rooms")
      .doc(roomId)
      .collection("users")
      .doc(userId)
      .set({
        name: alias,
        teacherSDP: "",
        studentSDP: ""
      });
  },

  delMember: (roomId, userId) => {
    return database
      .collection("rooms")
      .doc(roomId)
      .collection("users")
      .doc(userId)
      .delete();
  },

  watchRoom: (roomId, fn) => {
    return database
      .collection("rooms")
      .doc(roomId)
      .collection("users")
      .onSnapshot(fn);
  },

  watchMember: (roomId, userId, fn) => {
    return database
      .collection("rooms")
      .doc(roomId)
      .collection("users")
      .doc(userId)
      .onSnapshot(fn);
  },

  setSDP: (roomId, userId, data) => {
    return database
      .collection("rooms")
      .doc(roomId)
      .collection("users")
      .doc(userId)
      .update(data);
  },

  pushTeacherSDP: (roomId, userId, val) => {
    return database
      .collection("rooms")
      .doc(roomId)
      .collection("users")
      .doc(userId)
      .update({teacherSDPs: firebase.firestore.FieldValue.arrayUnion(val)});
  },

  pushStudentSDP: (roomId, userId, val) => {
    return database
      .collection("rooms")
      .doc(roomId)
      .collection("users")
      .doc(userId)
      .update({studentSDPs: firebase.firestore.FieldValue.arrayUnion(val)});
  },

  onSnapshot: (doc, f) => {
    return database
      .collection("rooms")
      .doc(doc)
      .onSnapshot(f);
  },

  update: (doc, data) => {
    return database
      .collection("rooms")
      .doc(doc)
      .update(data);
  }
};

